export default "__VITE_ASSET__Dwhc4ZQb__"